import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { priceListListQuery } from "@/features/price-lists/api";
import { PriceListsPage } from "@/features/price-lists/PriceListsPage";
import { validatePriceListSearch, type PriceListSearch } from "@/features/price-lists/search";
import { activeCompanyOf } from "@/lib/activeCompany";
import { sessionContextQuery } from "@/lib/session";

// Procurement → Master data → Purchase price lists (PX-PUR-320, ADR-051).

export const Route = createFileRoute("/_app/procurement/purchase-price-lists")({
  validateSearch: (raw: Record<string, unknown>) => validatePriceListSearch("purchase", raw),
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q }),
  loader: async ({ context, deps }) => {
    const ctx = await context.queryClient.ensureQueryData(sessionContextQuery);
    const companyId = activeCompanyOf(ctx)?.id;
    if (companyId)
      await context.queryClient.ensureInfiniteQueryData(priceListListQuery({ kind: "purchase", companyId, status: deps.status, q: deps.q }));
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<PriceListSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <PriceListsPage kind="purchase" search={search} setSearch={setSearch} />;
}
